import {q, useQueryData} from "../state";

export function useIsAdmin() {
  const whoAmI = useQueryData(q.whoAmIOnAccount());
  return whoAmI.roles.some(role => role.system_role === "Admin");
}
